import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-token-management-system',
  templateUrl: './token-management-system.component.html',
  styleUrls: ['./token-management-system.component.css']
})
export class TokenManagementSystemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
